<template>
    <span :style="{display:show}" id="TimeoutCounter"></span>
</template>
<!-- Scripts-->
<script>
export default {
  name: "PayForm_TransactionJunction",
  data() {
    return {
      show: "none",
    }
  },
  methods: {
      showForm(bool){
          this.show = bool?"block":"none";
          this.$parent.initPayTransactionJunction();
      }
  },
  created() {

  },
  mounted() {   
    
  }
};
</script>
<!-- Styles -->
<style scoped>
</style>